import { IApiRequest } from "@miplatform/types";
import {
  API_VERSION,
  SUBSCRIPTION_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ROLE = `${SUBSCRIPTION_SERVICE}/roles`;

export const roles = {
  getAll: async ({ filters, sort, top, skip }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ROLE}`,
      method: "get",
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  get: async (id: string) => {
    const options = await apiOptions({
      url: `${API_ROLE}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: API_ROLE,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ROLE}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ROLE}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  listByPermission: async ({
    permission,
    filters,
    sort,
    params,
    signal,
    top,
    skip,
  }: IApiRequest & { permission: string }) => {
    const options = await apiOptions({
      url: `${API_ROLE}/list/by-permission`,
      query: {
        permission,
      },
      filters,
      sort,
      params,
      signal,
      top,
      skip,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
};
